import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-enlargeimage',
  templateUrl: './enlargeimage.component.html',
  styleUrls: ['./enlargeimage.component.css']
})
export class EnlargeimageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
